import AppRouter from "./AppRouter";
import { Spin } from "antd";
import { IAppRouterProps } from "./AppRouter/AppRouter.types";
import { INavBarProps } from "./NavBar/NavBar.types";
import React from "react";

interface IProps {
  appRouterProps: IAppRouterProps;
  isSpinningAppRouter: boolean;
  navBarProps: INavBarProps;
}

const AppView: React.FC<IProps> = ({
  appRouterProps,
  isSpinningAppRouter,
  navBarProps
}) => (
  <div className="app-container">
    <Spin spinning={isSpinningAppRouter}>
      <AppRouter {...appRouterProps} navBarProps={navBarProps} />
    </Spin>
  </div>
);

export default AppView;
